import * as yup from "yup";

export type ChecklistSchema = {
  project_profile_id: number
  project_id: number
  trx_code: string
  transaction_date: string
  status_project: number
  start_date: string
  due_date: string
  finished_date: string
  employee_id: number
  customer_id: number
  department_id: number
  type_project: number
  type_project_id: number
  contact: string
  approve_status: number
  approve_date: string
  approve_by: string
  location_id: number
  link_asset_id: number
  company_code: string
  description: string
  create_at: string
  create_by: number
  update_at: string
  update_by: string
  is_deleted: boolean
  department_name: string
  customer_name: string
  employee_name: string
  project_name: string
  location_name: string
  updated_by: string
  checklist_data: any[]
}

export const validationChecklistSchema = yup.object().shape({
  project_checklist_id: yup.number().required(),
  project_boq_id: yup.number().required().min(1, "BOQ is required!"),
  vendor_id: yup.number().required().min(1, "Vendor is required!"),
  checklist_status: yup.number().required().min(1, "Status is required!"),
  detail: yup.string().required().min(1, "Detail is required!"),
  checklist_date: yup.string().required().min(1, "Check date is required!"),
  description: yup.string().required().min(1, "Description is required!"),
  employee_id: yup.number().required().min(1, "Checker is required!")
});

export const validationFormChecklistSchema = yup.object().shape({ checklist_data: yup.array().of(validationChecklistSchema).min(1, "At least one item must be filled in").required("Data checklist is required") })
export type ChecklistValdationSchema = yup.InferType<typeof validationChecklistSchema>;
export type FormChecklistValdationSchema = yup.InferType<typeof validationFormChecklistSchema>;